import React from 'react';
import SmiWidget from "../../components/smiWidgets/SmiWidget"

export const PopupModal = ({ show, onClose, isFull, isDesktop, widgetBlocks }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <span className="close-modal-button" onClick={onClose}>&times;</span>
          <SmiWidget isDesktop={isDesktop} isFull={isFull} blockIds={widgetBlocks.popupModal}/>
      </div>
    </div>
  );
};
